import { createMuiTheme } from '@material-ui/core/styles';

export const checkboxTheme = createMuiTheme({
    palette: {
        primary:{
            main:'#008000',      
        },
    },
});
